<template>
  <div
      style="justify-content: center"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
  >
    <div>
      <el-row :gutter="0">
        <el-col :span="24">
          <el-row
              :gutter="0"
              class="eltable row"
              style="display:flex;flex-wrap: wrap;margin-top:0px;"
          >
            <el-col :span="24">
              <div class="gridContent bggray2 fb tc">档案查询预约详情</div>
            </el-col>
            <el-col :span="4">
              <div class="gridContent bggray2 tc">预约人</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ applyAuthorization.reservationName }}</div>
            </el-col>
            <el-col :span="4">
              <div class="gridContent bggray2 tc">学号/工号</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ applyAuthorization.reservationId }}</div>
            </el-col>
            <el-col :span="4">
              <div class="gridContent bggray2 tc">联系电话</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ applyAuthorization.telephone }}</div>
            </el-col>
            <el-col :span="4">
              <div class="gridContent bggray2 tc">电子邮箱</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ applyAuthorization.mail}}</div>
            </el-col>
            <el-col :span="4">
              <div class="gridContent bggray2 tc">预约事项</div>
            </el-col>
            <el-col :span="20">
              <div class="gridContent">{{ applyAuthorization.appointmentMatters}}</div>
            </el-col>
            <el-col :span="4">
              <div
                  class="gridContent bggray2"
                  style="
                display: flex;
                align-items: center;
                justify-content: center;
                height: 119px;
              "
              >申请事由</div>
            </el-col>
            <el-col :span="20">
              <div class="gridContent" style="height: 119px">{{ applyAuthorization.reasonForApplication }}</div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import "@/static/css/my.css";
import { findArchiveQueryAppointment } from "@/api/archiveQueryAppointment";

export default {
  name: "archiveQueryDetails",
  data() {
    return {
      user: {},
      applyAuthorization: {},
      //id: "e015456ccbeb4248a5c8873e566f4b44", //a473f45f069d4b34bebf4f9c07d7d3c8,e015456ccbeb4248a5c8873e566f4b44
      id: "",
      url: "",
      loading: false
    };
  },
  computed: {},
  mounted() {
    this.user = JSON.parse(sessionStorage.getItem("userInfo"));
    console.log(this.user.userid);
    this.id = this.$route.query.id;
    this.findArchiveQueryAppointment();
  },
  methods: {
    async findArchiveQueryAppointment() {
      let data = await findArchiveQueryAppointment(this.id);
      this.applyAuthorization = data.data;
      this.loading = false;
      this.applyAuthorization.pics = JSON.parse(data.data.pics);
      console.log("pics==", this.applyAuthorization.pics);
      console.log("applyAuthorization===", this.applyAuthorization);
    },
    goBack() {
      this.$router.push("/userCenter");
    }
  }
};
</script>
<style scoped>
.el-tabs__item.is-active {
  color: #2c3e50 !important;
  font-weight: bold;
}

.eltable {
  border-left: 1px solid #ddd;
  margin-top: 20px;
  border-top: 1px solid #ddd;
}

.eltable .gridContent {
  padding: 10px 8px;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  min-height: 19px;
}

.rightTable {
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

.rightDiv {
  padding-top: 10px;
  margin-left: 10%;
  padding-left: 5px;
  overflow-y: scroll;
}

.el-rate__icon {
  font-size: 28px;
}

.bggray2 {
  background-color: #e2f3cf;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
  margin-right: 10px;
}

.avatar {
  width: 160px;
  height: 160px;
  float: left;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-right: 10px;
  line-height: 88px;
  text-align: center;
  /* display: block;  */
}

>>> .el-image__error,
>>> .el-image__inner,
>>> .el-image__placeholder {
  width: 160px;
  height: 160px;
}

>>> .el-step__title.is-finish {
  color: rgb(17, 1, 69);
  font-size: 14px;
  /* text-align: center; */
}

>>> .el-step__head.is-finish {
  color: #008a2c;
  border-color: #008a2c;
  font-size: 14px;
  text-align: center;
  /* justify-content: center; */
}

>>> .el-step__description.is-finish {
  color: rgb(17, 1, 69);
  font-size: 14px;
  /* text-align: center; */
}

::-webkit-scrollbar {
  width: 5px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.1);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}

.btn1.el-button {
  background-color: #008a2c;
  color: white;
}

.btn1.el-button:hover {
  color: white;
  border-color: #e0fae8;
  background-color: #008a2cc9;
}
</style>